export const ONBOARDING_TYPES = {
    UNVERIFIED: 'UNVERIFIED',
    EXPIRED_UNVERIFIED: 'EXPIRED_UNVERIFIED',
    REGULAR: 'REGULAR',
    VERIFIED: 'VERIFIED'
};
